import { Col, Divider, Modal, Row, Space, Spin, Timeline } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { MainLayout } from 'components';
import React, { useEffect, useState } from 'react';
import { WhiteEditIcon, TrendingUp } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';
import { feedbackApproval, historyApproval } from 'mock/approve-mockup';
import { useHistory, useLocation } from 'react-router-dom';
import Button from 'components/Button';
import { useMutation } from 'react-query';
import CartApi from 'apis/CartApi';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import CapitalByProduct from 'components/Modules/Allocated/Allocatedetails/CapitalByProduct';
import DropdownComponent from 'components/DropdownComponent';
import TableDetailApproveOrder from './TableDetailApproveOrder';
import { useUser } from 'contexts/User';
import Feedback from './Feedback';
import { openNotificationWithIcon } from 'utils/notification';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import moment from 'moment';

const DetailApproveOrderList = () => {
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const { state } = useLocation<{ cart: any }>();
  const [isOpenCapitalByProduct, setIsOpenCapitalByProduct] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [typeBtnApprove, setTypeBtnApprove] = useState(0);
  const [minRegister, setMinRegister] = useState<any>();
  const [maxRegister, setMaxRegister] = useState<any>();
  const [minQuantity, setMinQuantity] = useState<any>();
  const [maxQuantity, setMaxQuantity] = useState<any>();
  const [dataLog, setDataLog] = useState<any[]>([]);
  const [colorText, setColorText] = useState<any>();

  const { user } = useUser();
  const history = useHistory();

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const locationdata = useLocation<{
    order_shop: any;
    cart: any;
    isViewDetailAllBranch: any;
  }>();
  const { order_shop, cart, isViewDetailAllBranch } = locationdata.state;
  // console.log('order_shop: ', order_shop);
  const isBranch = !order_shop ? true : false;
  const isRoleBranch =
    user?.role.includes('cua_hang_truong') ||
    user?.role.includes('nguoi_dat_hang') ||
    user?.plantCode == 1000
      ? false
      : true;

  const cart_register_id = order_shop
    ? order_shop?.cart_order_cht_id
    : cart?.cart_register_id;
  // console.log('cart_register_id: ', cart_register_id);

  const params = {
    page: page.toString(),
    page_size: page_size.toString(),
    shop_id: user?.plantId,
    ...(user?.role.includes('cua_hang_truong')
      ? { cart_register_id: cart_register_id }
      : { cart_order_cht_id: cart_register_id }),
  };

  const paramsBranch = {
    page: page.toString(),
    page_size: page_size.toString(),
    branch_id: user?.plantId,
    cart_register_id,
    cart_order_branch_id: cart?.id,
    // ...(searchName && { ten_mau: searchName }),
    // ...(nhanhangSelected &&
    //   nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    // ...(donghangSelected &&
    //   donghangSelected.length != 0 && { dong_hang: donghangSelected }),
    // ...(nganhhangSelected &&
    //   nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    // ...(chungloaiSelected &&
    //   chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
  };

  const { mutate: refetch, isLoading: getCartOrderCHT } = useMutation(
    () =>
      isRoleBranch && isViewDetailAllBranch
        ? CartApi.getCartOrderAllBranch(paramsBranch)
        : CartApi.getCartCHT_view(params),

    {
      onSuccess: (res: any) => {
        setMinRegister(res.sum_min_cost_price);
        setMaxRegister(res.sum_max_cost_price);
        setMinQuantity(res.sum_order_min);
        setMaxQuantity(res.sum_order_max);
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e);
      },
    }
  );

  const { mutate: listLogApprove } = useMutation(['getlogApprove'], () => {
    return CartApi.getlogApprove(order_shop?.cart_order_cht_id)
      .then((res) => {
        setDataLog(res?.data);
        setColorText(
          res?.data[0].status == 0
            ? 'text-primary-50'
            : res?.data[0].status == 1
            ? 'text-primary-50'
            : res?.data[0].status == 2
            ? 'text-primary-50'
            : 'text-red-500'
        );
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const listHistoryApprove = dataLog.map((item, index) => {
    return {
      children: (
        <Space className="w-full" key={index} direction="vertical">
          <Row className="flex justify-between">
            <Col>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</Col>
            <Col className={` ${colorText}`}>
              {' '}
              {item.status == 0
                ? 'Mới tạo'
                : item.status == 1
                ? 'Chờ phê duyệt'
                : item.status == 2
                ? 'Đã duyệt'
                : item.status == 3
                ? 'Từ chối'
                : 'Chưa tạo'}
            </Col>
          </Row>

          <p className="mt-2">
            {item.user_created.fullName + '  |  ' + item.user_created.jobTitle}
          </p>

          <Col span={24} className="text-red-500">
            {item.note}
          </Col>
        </Space>
      ),
    };
  });

  // const {
  //   data: cartData,
  //   isLoading: getCartsLoading,
  //   mutate: postCartTVV,
  // } = useMutation(['getCartTVV', functionParams], () =>
  //   CartApi.postCartTVV(functionParams)
  // );

  useEffect(() => {
    refetch();
  }, [user?.plantId, page, page_size]);

  useEffect(() => {
    setTitle(`Mã đơn hàng #${cart?.cart_code} - ${cart?.cart_name}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Phê duyệt</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/list-approve">Phê duyệt đặt hàng</a>
          </p>
        ),
      },
      {
        title: (
          <p>
            <a onClick={() => history.goBack()}>{cart?.cart_name}</a>
          </p>
        ),
      },
      {
        title: <a>{order_shop?.ma_cua_hang}</a>,
      },
    ]);
    // setBreadcrumb([
    //   { title: <a href="">Phê duyệt</a> },
    //   { title: <a href="">Đơn hàng</a> },
    //   { title: <a href="">{cart?.cart_name}</a> },
    // ]);
    // postCartTVV();
  }, []);

  useEffect(() => {
    listLogApprove();
  }, [order_shop]);

  const { mutate: updateStatusOrder, isLoading: isUpdating } = useMutation(
    ['updateStatusOrder'],
    (params: any) => CartApi.updateStatusCart_CHT(params),
    {
      onSuccess: (response: any) => {
        // refetch();
        setModalOpen(false);
        openNotificationWithIcon(
          'success',
          `Đơn hàng đã ${
            typeBtnApprove == 0
              ? 'duyệt thành công!'
              : 'được yêu cầu hiệu chỉnh!'
          }`
        );
        history.goBack();
      },
      onError: (error: any) => {
        setModalOpen(false);
        openNotificationWithIcon('error', error.message);
      },
    }
  );

  const approveOrder = () => {
    const params = {
      id: cart?.id,
      id_cart_order_cht: order_shop?.cart_order_cht_id,
    };
    // Nếu đơn hàng trong trạng thái chờ
    // if (order_shop?.order_status == 1) {
    //   if (typeBtnApprove == 0) {
    //     updateStatusOrder({
    //       ...params,
    //       status: user?.role.includes('asm') ? 1 : 2,
    //     });
    //   } else {
    //     updateStatusOrder({
    //       ...params,
    //       status: user?.role.includes('asm') ? 2 : 3,
    //     });
    //   }
    // } else {
    //   openNotificationWithIcon(
    //     'error',
    //     `Đơn hàng đã ${
    //       order_shop?.order_status == 2 ? 'duyệt' : 'từ chối'
    //     } không thể thay đổi`
    //   );
    // }
    if (typeBtnApprove == 0) {
      updateStatusOrder({
        ...params,
        status: user?.role.includes('asm') ? 1 : 2,
      });
    } else {
      updateStatusOrder({
        ...params,
        status: user?.role.includes('asm') ? 2 : 3,
      });
    }
  };

  return (
    <MainLayout>
      <Spin spinning={isUpdating}>
        {/* Modal phê duyệt */}
        <Modal
          open={modalOpen}
          onCancel={() => {
            setModalOpen(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Xác nhận phê duyệt đơn hàng</p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">
                Bạn có chắc muốn{' '}
                {typeBtnApprove == 0 ? (
                  'duyệt'
                ) : (
                  <span className="text-red-500">từ chối</span>
                )}{' '}
                đơn hàng này không?
                <br />
                <span className="text-red-500 font-medium">
                  Lưu ý: không thể hoàn tác
                </span>
              </p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalOpen(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button onClick={approveOrder}>Đồng ý</Button>
            </Row>
          </Content>
        </Modal>
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          justify="end"
          className="my-3"
        >
          <Col span={4} className="flex items-center">
            <div
              className="text-[#00538F] text-base cursor-pointer"
              onClick={() => history.goBack()}
            >
              {'<'} Phê duyệt
            </div>
          </Col>
          <Col span={20} className="flex justify-end">
            <Space>
              {/* <Feedback /> */}

              {/* <Button
                noneBold={true}
                bgColor={'bg-white'}
                color="text-primary-50"
                border="border-primary-50"
                // onClick={toggleFilter}
              >
                Đề xuất
              </Button> */}

              {
                // (user?.plantCode == 1000 && isBranch) ||

                !user?.role.includes('cua_hang_truong') &&
                !user?.role.includes('nguoi_dat_hang') &&
                !isBranch ? (
                  <>
                    <Button
                      noneBold={true}
                      onClick={() =>
                        // updateStatusOrder({
                        //   id: cart?.id,
                        //   list_order_cht: [order_shop?.cart_order_cht_id],
                        //   status: 3,
                        // })
                        {
                          setTypeBtnApprove(1);
                          setModalOpen(true);
                        }
                      }
                      disabled={
                        user?.role.includes('asm')
                          ? order_shop?.asm_approve_status == 2 ||
                            order_shop?.order_status == 2
                          : order_shop?.order_status == 3
                      }
                      bgColor={
                        (
                          user?.role.includes('asm')
                            ? order_shop?.asm_approve_status != 2 &&
                              order_shop?.order_status != 2
                            : order_shop?.order_status != 3
                        )
                          ? 'bg-red-500'
                          : 'bg-gray-300'
                      }
                    >
                      Yêu cầu hiệu chỉnh
                    </Button>

                    <Button
                      noneBold={true}
                      onClick={() => {
                        setTypeBtnApprove(0);
                        setModalOpen(true);
                      }}
                      disabled={
                        user?.role.includes('asm')
                          ? order_shop?.asm_approve_status != 0
                          : order_shop?.order_status != 1
                      }
                      bgColor={
                        (
                          user?.role.includes('asm')
                            ? order_shop?.asm_approve_status == 0
                            : order_shop?.order_status == 1
                        )
                          ? 'bg-[#038F00]'
                          : 'bg-gray-300'
                      }
                    >
                      {' '}
                      Duyệt
                    </Button>
                  </>
                ) : (
                  <>
                    {/* <Button
                      noneBold={true}
                      bgColor="bg-white"
                      color="text-primary-50"
                      border="border-primary-50"
                    >
                      <TrendingUp />
                      Báo cáo
                    </Button>
                    <Button noneBold={true}>
                      <WhiteEditIcon />
                      Yêu cầu phê duyệt
                    </Button> */}
                  </>
                )
              }
            </Space>
          </Col>
        </Row>
        <Row gutter={[18, 0]}>
          <Col span={18}>
            {/* <DropdownComponent border={false} title="Vốn theo dòng hàng">
              <CapitalByProduct />
            </DropdownComponent> */}

            <TableDetailApproveOrder
              data={{
                minRegister,
                maxRegister,
                minQuantity,
                maxQuantity,
                order_shop,
                cart,
              }}
              id={
                order_shop
                  ? order_shop?.cart_order_cht_id
                  : cart?.cart_register_id
              }
              cartOrderBranchId={cart?.id}
              isViewDetailAllBranch={isViewDetailAllBranch}
              // isLoading={getCartsLoading}
            />
          </Col>
          <Col span={6}>
            <Space direction="vertical" className="w-full">
              <Col className="flex justify-end">
                <span
                  className="border border-solid boder-primary-50 rounded-lg font-sans text-sm py-1 px-2 leading-5 bg-gray-100 uppercase"
                  style={{ color: '#4da6ff' }}
                >
                  {order_shop?.order_status == 0
                    ? 'Mới tạo'
                    : order_shop?.order_status == 1
                    ? 'Chờ duyệt'
                    : order_shop?.order_status == 2
                    ? 'Đã duyệt'
                    : order_shop?.order_status == 3
                    ? 'Từ chối'
                    : order_shop?.order_status == 4
                    ? '-'
                    : undefined}
                </span>
              </Col>
              <DropdownComponent title="Thông tin đăng ký">
                <p>{order_shop?.address}</p>
                <p>{user?.division}</p>
                <DropdownComponent title="Xem chi tiết">
                  <Space
                    className="w-full"
                    direction="vertical"
                    size={'middle'}
                  >
                    <div>
                      <Row>
                        <Col className="text-neutral-50" span={12}>
                          Quận/Huyện
                        </Col>
                        <Col span={12} align="right">
                          <strong>{order_shop?.district}</strong>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-neutral-50" span={12}>
                          Tier
                        </Col>
                        <Col span={12} align="right">
                          <strong>{order_shop?.tier_name}</strong>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-neutral-50" span={12}>
                          MHKD
                        </Col>
                        <Col span={12} align="right">
                          <strong>
                            {order_shop?.mo_hinh_kinh_doanh ?? '-'}
                          </strong>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-neutral-50" span={12}>
                          CapCH
                        </Col>
                        <Col span={12} align="right">
                          <strong>{order_shop?.cap_cua_hang}</strong>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <p className="font-bold  mb-3 text-neutral-50">
                        Vốn đăng ký
                      </p>
                      <Row>
                        <Col span={12}>
                          <p className="border-2 text-center bg-primary-50 text-white font-bold">
                            Min
                          </p>
                          <p className="border-2 text-center ">
                            {formatCurrencyVND(order_shop?.shop_cap_order_min)}
                          </p>
                        </Col>
                        <Col span={12}>
                          <p className="border-2 text-center bg-primary-50 text-white font-bold">
                            Max
                          </p>
                          <p className="border-2 text-center ">
                            {formatCurrencyVND(order_shop?.shop_cap_order_max)}
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <p className="font-bold mb-3 text-neutral-50">
                        Chi nhánh phân bố
                      </p>
                      <Row>
                        <Col span={12}>
                          <p className="border-2 text-center font-bold bg-primary-50 text-white">
                            Min
                          </p>
                          <p className="border-2 text-center ">
                            {formatCurrencyVND(order_shop?.branch_cap_min)}
                          </p>
                        </Col>
                        <Col span={12}>
                          <p className="border-2 text-center bg-primary-50 text-white font-bold">
                            Max
                          </p>
                          <p className="border-2 text-center ">
                            {formatCurrencyVND(order_shop?.branch_cap_max)}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </Space>
                </DropdownComponent>
              </DropdownComponent>

              {/* <DropdownComponent title="Kiểm tra đăng ký">
                <p className=" text-red-500">35 mẫu lỗi</p>

                <DropdownComponent title="Xem chi tiết">
                  <Row gutter={[0, 12]}>
                    <Col>
                      <Space direction="vertical">
                        <p>
                          Không đăng ký mẫu mới HHKN -{' '}
                          <strong className="text-primary-50">(10)</strong>
                        </p>

                        <p>
                          Đạt lẻ cặp/bộ -{' '}
                          <strong className="text-primary-50">(10)</strong>
                        </p>
                        <p>
                          Đặt thiếu mức chưng bày tủ hàng{' '}
                          <strong className="text-primary-50">(10)</strong>
                        </p>
                      </Space>
                    </Col>
                  </Row>
                </DropdownComponent>
              </DropdownComponent> */}

              <DropdownComponent title="Lịch sử phê duyệt">
                <Timeline items={listHistoryApprove} />
              </DropdownComponent>
            </Space>
          </Col>
        </Row>
      </Spin>
    </MainLayout>
  );
};

export default DetailApproveOrderList;
